"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORK_PERMIT_QUESTION_GROUPS = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const Questions = require("../../questions/questions");
const static_1 = require("../../static");
const answer_1 = require("../../utils/answer");
const group_1 = require("../../utils/group");
const { Question } = Questions;
exports.WORK_PERMIT_QUESTION_GROUPS = [
    (0, group_1.group)({
        uniqueKey: "APPLICANT_WORK_PERMIT_GETTING_STARTED_PART1",
        title: "Your Personal Information",
        subtitle: "Please confirm your full legal name and your date or birth (as shown on your passport).",
        id: 101,
        content: [
            Question["First name(s)"].label("PD_1"),
            Question["Last name"].label("PD_2"),
            Question["Date of Birth"].label("PD_7"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "APPLICANT_WORK_PERMIT_GETTING_STARTED_PART2",
        title: "Your Work Information",
        subtitle: "Please complete the questions below related to your citizenship and your details of intended work.",
        id: 102,
        content: [
            Question["What type of work permit are you applying for?"].label("PD_18"),
            Question["Country of Citizenship"].label("PD_10"),
            Question["Have you lived in your current country of residence for longer than 6 months?"]
                .label("GS_1")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Have you lived any other country for 6 months or longer (continuously) in the last 12 months?"]
                    .label("GS_2")
                    .ifAnswerEquals(answer_1.answer.yes)
                    .renderTheseQuestions([
                    Question["What country did you live in, in the last 12 months (for 6 months or longer)?"].label("GS_3"),
                ]),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "APPLICANT_WORK_PERMIT_INSIDE_CANADA_GETTING_STARTED_PART2",
        title: "Your Work Information",
        subtitle: "Please complete the questions below related to your citizenship and your details of intended work.",
        id: 109,
        content: [
            Question["What type of work permit extension are you applying for?"]
                .label("WP_23")
                .ifAnswerEquals("Other")
                .renderTheseQuestions([
                Question["What other type of work permit extension are you applying for?"].label("WP_24"),
            ]),
            Question["Which province will you be working in?"].label("WP_3"),
            Question["Country of Citizenship"].label("PD_10"),
            Question["Have you lived in your current country of residence for longer than 6 months?"]
                .label("GS_1")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Have you lived any other country for 6 months or longer (continuously) in the last 12 months?"]
                    .label("GS_2")
                    .ifAnswerEquals(answer_1.answer.yes)
                    .renderTheseQuestions([
                    Question["What country did you live in, in the last 12 months (for 6 months or longer)?"].label("GS_3"),
                ]),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "APPLICANT_WORK_PERMIT_GETTING_STARTED_PART3",
        title: "Your Family Information",
        subtitle: "You are allowed to bring immediate family members with you to Canada. If you plan on bringing family members, please add them all below.",
        id: 103,
        content: [
            Question["Are you bringing any family members (spouse, common-law partner, children) with you to Canada?"]
                .label("PD_11")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["If you are bringing a spouse, common law partner and/or children with you to Canada, please add each of them here!"].label("CUS_1"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "DETAILS_WORK",
        id: 104,
        title: "Information about your intended work in Canada",
        subtitle: undefined,
        content: [
            Question["What is the name of your employer?"].label("WP_1"),
            Question["What is the full address of your employer?"].label("WP_2"),
            Question["Which province will you be working in?"]
                .label("WP_3")
                .ifAnswerEquals(static_1.provinces.alberta)
                .renderTheseQuestions([
                Question["What is the name of the city in Alberta"].label("WP_4"),
            ])
                .ifAnswerEquals(static_1.provinces.britishColumbia)
                .renderTheseQuestions([
                Question["What is the name of the city in British Columbia"].label("WP_5"),
            ])
                .ifAnswerEquals(static_1.provinces.manitoba)
                .renderTheseQuestions([
                Question["What is the name of the city in Manitoba"].label("WP_6"),
            ])
                .ifAnswerEquals(static_1.provinces.newBrunswick)
                .renderTheseQuestions([
                Question["What is the name of the city in New Brunswick"].label("WP_7"),
            ])
                .ifAnswerEquals(static_1.provinces.newfoundland)
                .renderTheseQuestions([
                Question["What is the name of the city in Newfoundland"].label("WP_8"),
            ])
                .ifAnswerEquals(static_1.provinces.northwestTerritories)
                .renderTheseQuestions([
                Question["What is the name of the city in Northwest Territories"].label("WP_9"),
            ])
                .ifAnswerEquals(static_1.provinces.novaScotia)
                .renderTheseQuestions([
                Question["What is the name of the city in Nova Scotia"].label("WP_10"),
            ])
                .ifAnswerEquals(static_1.provinces.nunavut)
                .renderTheseQuestions([
                Question["What is the name of the city in Nunavut"].label("WP_11"),
            ])
                .ifAnswerEquals(static_1.provinces.ontario)
                .renderTheseQuestions([
                Question["What is the name of the city in Ontario"].label("WP_12"),
            ])
                .ifAnswerEquals(static_1.provinces.princeEdwardIsland)
                .renderTheseQuestions([
                Question["What is the name of the city in Prince Edward Island"].label("WP_13"),
            ])
                .ifAnswerEquals(static_1.provinces.quebec)
                .renderTheseQuestions([
                Question["What is the name of the city in Quebec"].label("WP_14"),
            ])
                .ifAnswerEquals(static_1.provinces.saskatchewan)
                .renderTheseQuestions([
                Question["What is the name of the city in Saskatchewan"].label("WP_15"),
            ])
                .ifAnswerEquals(static_1.provinces.yukon)
                .renderTheseQuestions([
                Question["What is the name of the city in Yukon"].label("WP_16"),
            ]),
            Question["What is the address of where you will be working in Canada?"].label("WP_17"),
            Question["What will your job title be?"].label("WP_18"),
            Question["Can you provide a brief description of your job duties while working in Canada?"].label("WP_19"),
            Question["What day will you start working?"].label("WP_20"),
            Question["What day will you stop working?"].label("WP_21"),
            Question["LMIA # or Offer of Employment #"].label("WP_22"),
        ],
    }),
];
